module.exports = __webpack_public_path__ + "static/media/telegram_grey_big.d92910cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/telegram_grey_big.png
// module id = ./src/assets/media/telegram_grey_big.png
// module chunks = 16